// extracted by mini-css-extract-plugin
export var bottom = "Section-module--bottom--c40ab";
export var first = "Section-module--first--fce61";
export var firstExtraPadding = "Section-module--firstExtraPadding--64d09";
export var shape = "Section-module--shape--5a43a";
export var squiggles = "Section-module--squiggles--a3ef6";
export var top = "Section-module--top--8165d";
export var waves = "Section-module--waves--dd3e4";
export var wrapper = "Section-module--wrapper--57c7f";